module.exports = __webpack_public_path__ + "static/img/orange-echars.9f1b4332.png";